module.exports = __webpack_public_path__ + "img/japanese-ice-tea.c0f4e08b.jpg";